import { render, staticRenderFns } from "./SpaceOffice.vue?vue&type=template&id=12e0d3c2&scoped=true"
import script from "./SpaceOffice.vue?vue&type=script&lang=js"
export * from "./SpaceOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e0d3c2",
  null
  
)

export default component.exports